import { callAct, isOk } from './apiConfig';

/*
 * customers — real customer CRM data, aggregated server-side from reservations
 * (customersList / customerHistory acts). Customers are keyed by a prefixed id:
 *   u:<userID> (account), p:<phone> (manual w/ phone), m:<orderID> (one-off).
 * spend / tags / notes have NO backend source yet — the UI supplies safe defaults.
 */

// The business's customers. Returns [] on error/empty (never throws).
export async function listCustomers() {
    try {
        const envelope = await callAct('customersList', {});
        if (isOk(envelope) && Array.isArray(envelope.data)) return envelope.data;
    } catch (e) { /* act not available */ }
    return [];
}

// One customer's reservation history (drawer timeline). Returns [] on error.
export async function customerHistory(customerId) {
    try {
        const envelope = await callAct('customerHistory', { customerId });
        if (isOk(envelope) && Array.isArray(envelope.data)) return envelope.data;
    } catch (e) { /* ignore */ }
    return [];
}

export default { listCustomers, customerHistory };
